export const dev_site_id =
  "f723bac8-ca56-4c56-9b9f-1e6121d8bf7d,0a0a82d1-7b28-4672-b20d-a49e5038050c";
export const test_site_id =
  "c6ce51d1-885e-4aef-826f-014adcc8e425,0a0a82d1-7b28-4672-b20d-a49e5038050c";
export const stage_site_id =
  "6cf1c962-bf6b-4c12-a168-78a3c42e2faa,0a0a82d1-7b28-4672-b20d-a49e5038050c";
// export const prod_site_id =
// 	"6cf1c962-bf6b-4c12-a168-78a3c42e2faa,0a0a82d1-7b28-4672-b20d-a49e5038050c";
export const prod_site_id =
  "2ee3654e-7778-4d4a-a61e-e8818a62923d,4c013a83-51b7-4167-8143-8987d0b41dbb";

  /** return current environment id */
function getCurrentEnvironmentSiteId() {
  // if ( window.location.href.indexOf("https://streamdatum-dc") >= 0 || window.location.href.indexOf("operationsportal") >= 0  ) {
  if ( window.location.href.indexOf("app-ui-dcopl-prd-eus") >= 0 || window.location.href.indexOf("https://dcop.stream-dc") >= 0  ) {
    return prod_site_id;
  } else if (window.location.href.indexOf("app-ui-dcopl-stg-eus") > 0 || window.location.href.indexOf("stage-dcop.stream-dc") >= 0) {
    return stage_site_id;
  } else if (window.location.href.indexOf("app-ui-dcopl-tst-eus" ) > 0 || window.location.href.indexOf("test-dcop.stream-dc") >= 0) {
    return test_site_id;
  } else if (window.location.href.indexOf("localhost") > 0) {
    return dev_site_id;
  }
  return dev_site_id;
}

export let SPSToken = "";
export let SPSDrive = null;

/** set token */
export const setSPSToken = token => {
  SPSToken = token;
};

/** Set share point drive */
export const setSPSDrive = driveList => {
  SPSDrive = driveList;
};

/** Get drive id */
function getDriveId(PropertyKey) {
  try {
    if (SPSDrive && SPSDrive.value) {
      return SPSDrive.value.filter(data => {
        return data.name == PropertyKey;
      })[0].id;
    }
  } catch (e) { /* empty */ }
}

/** Return share point URL */
export function getSharepointUrl(name = "getSps", PropertyKey, fileName = "") {
  switch (name) {
    case "getSps":
      return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId()}/lists/${PropertyKey}/drive/root/children?expand=listItem($expand=fields)`;

    case "createDrive":
      return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId()}/lists`;

    case "uploadFile":
      return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId()}/lists/${PropertyKey}/drive/root:/${fileName}:/content?expand=listItem($expand=fields)`;

    case "uploadMetadata":
      // Here fileName is a itemId
      return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId()}/lists/${PropertyKey}/items/${fileName}/fields`;

    case "uploadFileSession":
      return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId()}/lists/${PropertyKey}/drive/root:/${fileName}:/createUploadSession`;
    case "deleteFile":
      // Here fileName is a itemId
      return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId()}/lists/${PropertyKey}/items/${fileName}`;
    case "getDriveList":
      // Here fileName is a itemId
      return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId()}/drives`;
    case "deleteFileByDrive":
      return `https://graph.microsoft.com/v1.0/sites/${getCurrentEnvironmentSiteId()}/drives/${getDriveId(
        PropertyKey
      )}/root:/${fileName}`;
  }
}
